//GET_AIRTICKET_LIST
export const GET_ADMIN_AIRTICKET_LIST_REQUEST =
  "GET_ADMIN_AIRTICKET_LIST_REQUEST";
export const GET_ADMIN_AIRTICKET_LIST_SUCCESS =
  "GET_ADMIN_AIRTICKET_LIST_SUCCESS";
export const GET_ADMIN_AIRTICKET_LIST_FAIL = "GET_ADMIN_AIRTICKET_LIST_FAIL";

//CREATE_AIRTICKET
export const CREATE_ADMIN_AIRTICKET_REQUEST = "CREATE_ADMIN_AIRTICKET_REQUEST";
export const CREATE_ADMIN_AIRTICKET_SUCCESS = "CREATE_ADMIN_AIRTICKET_SUCCESS";
export const CREATE_ADMIN_AIRTICKET_FAIL = "CREATE_ADMIN_AIRTICKET_FAIL";

//DELETE_AIRTICKET
export const DELETE_ADMIN_AIRTICKET_REQUEST = "DELETE_ADMIN_AIRTICKET_REQUEST";
export const DELETE_ADMIN_AIRTICKET_SUCCESS = "DELETE_ADMIN_AIRTICKET_SUCCESS";
export const DELETE_ADMIN_AIRTICKET_FAIL = "DELETE_ADMIN_AIRTICKET_FAIL";

//UPDATE_AIRTICKET
export const UPDATE_ADMIN_AIRTICKET_REQUEST = "UPDATE_ADMIN_AIRTICKET_REQUEST";
export const UPDATE_ADMIN_AIRTICKET_SUCCESS = "UPDATE_ADMIN_AIRTICKET_SUCCESS";
export const UPDATE_ADMIN_AIRTICKET_FAIL = "UPDATE_ADMIN_AIRTICKET_FAIL";
